import loadImage from "blueimp-load-image";

interface ImageData {
  imageHead: ArrayBuffer[];
  originalHeight: number;
  originalWidth: number;
  exif?: any;
}

type CanvasCallback = (blob: Blob) => void;

interface Canvas {
  toBlob: (callback: CanvasCallback, mimeType: string) => void;
}

export const changeOrientation = (file: File) => {
  return new Promise(
    (resolve: (value: Blob) => void, reject: (reason: string) => void) => {
      loadImage(
        file,
        (img: Canvas, data: ImageData) => {
          if (data.imageHead && data.exif) {
            loadImage.writeExifData(data.imageHead, data, "Orientation", 1);
            img.toBlob((blob: Blob) => {
              loadImage.replaceHead(blob, data.imageHead, (newBlob: Blob) => {
                return resolve(newBlob);
              });
            }, "image/jpeg");
          } else {
            return resolve(file);
          }
        },
        { meta: true, orientation: true, canvas: true }
      );
    }
  );
};
